// EC Sales List: page text and the list of countries. Generated file.
const config = {
  "slug": "ec-sales-list",
  "name": "EC Sales List",
  "menu": {
    "show": false,
    "label": "EC Sales List",
    "desc": "Reports of cross-border sales to EU businesses"
  },
  "meta": {
    "title": "EC Sales List: EU Sales Reporting From Your ERP | Taxera",
    "description": "The EC Sales List (recapitulative statement) explained: what it reports, how often it is filed, and how Taxera builds it from your ERP and checks it."
  },
  "hero": {
    "h1": "EC Sales List, built from your own ERP data.",
    "h1Accent": "Checked against your VAT return.",
    "text": "Every sale of goods or services to a business in another EU country has to be reported, customer by customer. Taxera builds the list straight from your ERP and ties it back to your VAT return, so the two always agree.",
    "secondaryCta": "See requirements by country"
  },
  "countriesSection": {
    "heading": "EC Sales List requirements by country",
    "intro": "Every country runs the EC Sales List its own way, with its own deadlines and portal. Pick yours to see who has to report, the key dates and how the process works.",
    "trackerPath": "/tracker/vat_returns"
  },
  "what": {
    "heading": "What is the EC Sales List, in plain words?",
    "paragraphs": [
      "The EC Sales List, also called the recapitulative statement or EU sales list, is a periodic report of the supplies a business makes to VAT-registered customers in other EU countries. For each customer VAT number it shows the total value of what was supplied.",
      "Tax authorities use it to cross-check cross-border trade between countries: what you report as sold to a customer should match what the customer's country sees as bought. It is filed in addition to the VAT return, usually monthly or quarterly depending on the country and the type of supply. Names and forms differ by country."
    ],
    "explainer": {
      "heading": "Three things the EC Sales List depends on",
      "items": [
        {
          "icon": "Users",
          "title": "The right customers",
          "text": "Each line is tied to a customer VAT number in another EU country. A wrong or missing number means a wrong report."
        },
        {
          "icon": "Database",
          "title": "The right figures",
          "text": "The values must come from the same invoices as the intra-EU boxes on your VAT return, or the authority will see a mismatch."
        },
        {
          "icon": "Clock",
          "title": "The right time",
          "text": "Periods and deadlines differ by country and by what you supply, and they change. A late list can bring a penalty even when the figures are right."
        }
      ]
    }
  },
  "steps": {
    "heading": "How Taxera does it",
    "intro": "The same ERP integration that prepares your VAT returns prepares the EC Sales List.",
    "items": [
      {
        "icon": "PlugZap",
        "title": "Connect to your ERP",
        "text": "Taxera sits inside your ERP landscape. No file exports and no manual uploads."
      },
      {
        "icon": "Calculator",
        "title": "Build the list",
        "text": "Cross-border supplies are picked up from your transactions and grouped by customer VAT number and by type, using each country's layout."
      },
      {
        "icon": "Scale",
        "title": "Check against the VAT return",
        "text": "The list is matched to the intra-EU figures on the VAT return, and differences are flagged before anyone signs off."
      },
      {
        "icon": "CheckCircle2",
        "title": "Review and approve",
        "text": "Your team reviews the figures with drill-down to the source transactions. The list is then ready for the route your country uses."
      }
    ]
  },
  "benefits": {
    "heading": "What changes for your team",
    "items": [
      {
        "icon": "FileSpreadsheet",
        "title": "No spreadsheets in the middle",
        "text": "The list comes from your ERP without anyone re-keying or patching numbers."
      },
      {
        "icon": "Layers",
        "title": "One integration for everything",
        "text": "The EC Sales List uses the same data as your VAT returns, Intrastat, e-Invoicing and SAF-T, so the numbers agree."
      },
      {
        "icon": "RefreshCw",
        "title": "Reconciled by design",
        "text": "Every list is tied to the VAT return it belongs to, which is what authorities compare."
      },
      {
        "icon": "BellRing",
        "title": "Rule changes are our problem",
        "text": "When a country changes a form, a period or a deadline, we track it and update the platform."
      }
    ]
  },
  "faq": {
    "heading": "EC Sales List, questions answered",
    "items": [
      {
        "q": "What is an EC Sales List?",
        "a": "An EC Sales List is a periodic report of supplies to VAT-registered businesses in other EU countries. For each customer VAT number it shows the total value supplied in the period. It is also called the recapitulative statement or EU sales list."
      },
      {
        "q": "Who has to file an EC Sales List?",
        "a": "Generally, businesses that supply goods, and in many cases certain services, to VAT-registered customers in other EU countries. The exact rules, forms and thresholds are set by each country, so check the official guidance for yours."
      },
      {
        "q": "How often is it filed?",
        "a": "The EU rules make quarterly the baseline, and countries can require monthly filing, often for goods or above a value threshold. Deadlines differ by country and change, so check the official rules."
      },
      {
        "q": "How does the EC Sales List relate to the VAT return and Intrastat?",
        "a": "They report different parts of the same cross-border activity. The VAT return reports the tax, the EC Sales List reports who you sold to, and Intrastat reports the movement of goods for trade statistics. The EC Sales List should agree with the intra-EU figures on the VAT return."
      },
      {
        "q": "How does Taxera build the EC Sales List?",
        "a": "Taxera's middleware connects to your ERP, picks up the cross-border supplies, groups them by customer VAT number, checks them against the VAT return and gives your team the list to review and approve, with drill-down to the source data."
      },
      {
        "q": "Do we need a separate tool for every country?",
        "a": "No. Taxera is one platform with one ERP integration. Country rules and layouts are handled inside the platform, alongside your VAT returns."
      }
    ]
  },
  "related": [
    {
      "to": "/solutions/vat-returns",
      "label": "VAT Returns",
      "note": "The return the list must agree with"
    },
    {
      "to": "/solutions/intrastat",
      "label": "Intrastat",
      "note": "Goods movements, same data"
    },
    {
      "to": "/solutions/vat-groups",
      "label": "VAT Groups",
      "note": "One return for several entities"
    },
    {
      "to": "/tracker/vat_returns",
      "label": "Live VAT reporting changes",
      "note": "Free Global Tax Tracker"
    }
  ],
  "cta": {
    "heading": "See the EC Sales List built from your own ERP data",
    "text": "Book a short demo. We will show you the path from your ledgers to a list that is ready to go."
  },
  "country": {
    "eyebrow": "EC Sales List {name}",
    "headingShort": "EC Sales List in {name}: {short} explained",
    "headingPlain": "EC Sales List in {name}, explained",
    "mandateLabel": "The obligation",
    "whoLabel": "Who must report",
    "howLabel": "How it works",
    "datesHeading": "Key dates for {name}",
    "leftHeading": "What the report contains",
    "rightHeading": "What your ERP has to deliver",
    "flowHeading": "The process, step by step",
    "linkedHeading": "Linked obligations in {name}",
    "faqHeading": "EC Sales List {name}: questions, answered",
    "moreHeading": "More EC Sales List guides",
    "allLabel": "All EC Sales List countries",
    "otherLabel": "EC Sales List {name}",
    "downloadTitle": "Keep this guide",
    "downloadText": "Download the {name} EC Sales List guide as a PDF. It has the same content as this page.",
    "printTitle": "EC Sales List guide: {name}",
    "trackerPath": "/tracker/vat_returns",
    "faqs": [
      {
        "q": "What is the EC Sales List obligation in {name}?",
        "a": [
          "mandateName",
          "summary"
        ]
      },
      {
        "q": "Who has to report in {name}?",
        "a": [
          "inScope"
        ]
      },
      {
        "q": "What are the key dates in {name}?",
        "a": [
          "keyDates"
        ]
      },
      {
        "q": "How does reporting work in {name}?",
        "a": [
          "process"
        ]
      },
      {
        "q": "What does the report contain in {name}?",
        "a": [
          "businessProcess"
        ]
      },
      {
        "q": "Where can I find the official rules in {name}?",
        "a": [
          "officialSources"
        ]
      }
    ]
  },
  "countries": [
    {
      "slug": "germany",
      "code": "DE",
      "name": "Germany",
      "shortName": "ZM",
      "region": "Europe",
      "status": "mandatory",
      "statusLabel": "Required, monthly or quarterly",
      "reviewed": "October 2026",
      "title": "EC Sales List in Germany (ZM): Rules Explained | Taxera",
      "description": "How the EC Sales List works in Germany: who reports, the key dates, how the report is prepared and what your ERP has to deliver."
    },
    {
      "slug": "france",
      "code": "FR",
      "name": "France",
      "shortName": "DES",
      "region": "Europe",
      "status": "mandatory",
      "statusLabel": "Required, monthly",
      "reviewed": "October 2026",
      "title": "EC Sales List in France (DES): Rules Explained | Taxera",
      "description": "How the EC Sales List works in France: who reports, the key dates, how the report is prepared and what your ERP has to deliver."
    },
    {
      "slug": "spain",
      "code": "ES",
      "name": "Spain",
      "shortName": "Modelo 349",
      "region": "Europe",
      "status": "mandatory",
      "statusLabel": "Required, monthly or quarterly",
      "reviewed": "October 2026",
      "title": "EC Sales List in Spain (Modelo 349): Rules Explained | Taxera",
      "description": "How the EC Sales List works in Spain: who reports, the key dates, how the report is prepared and what your ERP has to deliver."
    },
    {
      "slug": "netherlands",
      "code": "NL",
      "name": "the Netherlands",
      "shortName": "ICP",
      "region": "Europe",
      "status": "mandatory",
      "statusLabel": "Required, monthly or quarterly",
      "reviewed": "October 2026",
      "title": "EC Sales List in the Netherlands: Rules Explained | Taxera",
      "description": "How the EC Sales List works in the Netherlands: who reports, the key dates, how the report is prepared and what your ERP has to deliver."
    },
    {
      "slug": "poland",
      "code": "PL",
      "name": "Poland",
      "shortName": "VAT-UE",
      "region": "Europe",
      "status": "mandatory",
      "statusLabel": "Required, monthly or quarterly",
      "reviewed": "October 2026",
      "title": "EC Sales List in Poland (VAT-UE): Rules Explained | Taxera",
      "description": "How the EC Sales List works in Poland: who reports, the key dates, how the report is prepared and what your ERP has to deliver."
    }
  ]
};
export default config;
